<template>
  <text
    :x="x"
    :y="y"
    :text-anchor="textAnchor"
    :font-size="font.size"
    :font-family="font.family"
    :fill="font.color"
  >
    <tspan
      v-for="(line, i) in lines"
      :key="`line-${i}`"
      :x="x"
      :dy="i > 0 ? font.lineHeight : 0"
      dominant-baseline="text-before-edge"
    >{{ line }}</tspan> <!-- eslint-disable-line vue/multiline-html-element-content-newline -->
  </text>
</template>

<script>
export default {
  name: 'MultilineText',
  props: {
    lines: {
      type: Array,
      required: true
    },
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      required: true
    },
    xAlign: {
      type: String,
      required: true,
      validator: function (value) {
        return ['left', 'center', 'right'].includes(value)
      }
    },
    font: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    textAnchor () {
      return {
        left: 'start',
        center: 'middle',
        right: 'end'
      }[this.xAlign]
    }
  }
}
</script>
